<div class="input-slider">
  <div class="input-slider__container">
    @if (label()) {
      <mat-label class="input-slider__label">
        @if (hint()) {
          <mat-icon
            class="input-slider__hint"
            [matTooltip]="hint()"
          >
            info
          </mat-icon>
        }
        <div class="input-slider__label-text">
          {{ label() }}
        </div>
      </mat-label>
    }
    <mat-slider
      #slider
      class="input-slider__item"
      discrete
      [disabled]="showMode()"
      [min]="min()"
      [step]="step()"
      [max]="(max() | toNumber) > 0 ? max() : MAX_RANGE_VALUE"
      [displayWith]="displayWith()"
    >
      <input
        class="input-slider__input"
        matSliderStartThumb
        [formControl]="group().controls.min"
      />
      <input
        class="input-slider__input"
        matSliderEndThumb
        [formControl]="group().controls.max"
      />
    </mat-slider>
  </div>
</div>
